// 대시보드 사용량 카드 — 사진 저장 용량·이번 달 알림톡 · 넘으면 「한도 넘음」 · 막지 않는다.

import type { PlanUsage } from "@buildpy/core/modules/plan/usage-limit";
import Pill from "@buildpy/ui/pill";
import SectionCard from "@buildpy/ui/section-card";
import { Link } from "@/lib/nav";
import { PLAN_INTEREST_PATH, PLAN_SETTINGS_PATH } from "@/modules/plan/copy";
import UsageMeterRow from "@/modules/plan/ui/usage-meter";
import { notifyAmountOf, storageAmountOf } from "@/modules/plan/ui/usage-meter-state";
import { notifyOverNoteOf, OVER_LIMIT_LABEL } from "./usage-card-state";

const LINK = "inline-flex min-h-11 items-center text-sm font-medium text-primary underline underline-offset-4 hover:text-foreground";

interface Props {
  usage: PlanUsage;
  // 「알림톡 · 10월」 의 달(1~12).
  month: number;
}

const UsageCard = ({ usage, month }: Props) => {
  const warned = usage.storage.level !== "ok" || usage.notify.level !== "ok";
  return (
    <SectionCard
      actions={
        <Link className={LINK} href={PLAN_SETTINGS_PATH}>
          요금제 보기
        </Link>
      }
      className="flex flex-col gap-4"
      data-testid="dashboard-usage"
      title="이번 달 사용량">
      <UsageMeterRow
        amount={storageAmountOf(usage.storage)}
        badge={usage.storage.level === "over" ? <Pill tone="danger">{OVER_LIMIT_LABEL}</Pill> : null}
        label="사진 저장 용량"
        meter={usage.storage}
        note={usage.storage.level === "over" ? "한도를 넘어도 사진은 계속 올라갑니다." : undefined}
        testId="dashboard-usage-storage"
      />
      <UsageMeterRow
        amount={notifyAmountOf(usage.notify)}
        badge={usage.notify.level === "over" ? <Pill tone="danger">{OVER_LIMIT_LABEL}</Pill> : null}
        label={`알림톡 · ${month}월`}
        meter={usage.notify}
        note={notifyOverNoteOf(usage) ?? undefined}
        testId="dashboard-usage-notify"
      />
      {warned && (
        <Link className={LINK} data-testid="dashboard-usage-interest" href={PLAN_INTEREST_PATH}>
          더 큰 요금제 출시 알림 받기
        </Link>
      )}
    </SectionCard>
  );
};

export default UsageCard;
